let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jCwJz")).then(() => parcelRequire('8QWdM'));